import { COLORS } from './chartColors';
import { sortLabelsChronologically } from './helpers/dateHelpers';
import { parseDataKey } from './helpers/dataHelpers';

interface SelectedEntity {
  id: number;
  name: string;
}

interface ApplicationRecord {
  job_id: string;
}

interface ApplicationData {
  data: ApplicationRecord[] | { reportNotFound: boolean };
}

interface MonthlyAverages {
  [monthLabel: string]: number;
}

export const jobAverageTimeTransformer = (
  data: Record<string, ApplicationData>,
  selectedEntities: SelectedEntity[]
) => {
  const monthlyAverages: MonthlyAverages = {};

  Object.entries(data).forEach(([key, value]) => {
    const { monthLabel, shouldInclude } = parseDataKey(key, selectedEntities);

    if (!shouldInclude) return;

    if (Array.isArray(value.data)) {
      // Count applications per job id
      const applicationsPerJob = value.data.reduce(
        (acc, record) => {
          if (!record.job_id) return acc;
          acc[record.job_id] = (acc[record.job_id] || 0) + 1;
          return acc;
        },
        {} as Record<string, number>
      );

      // Calculate average applications per job
      const totalApplications = Object.values(applicationsPerJob).reduce(
        (sum, count) => sum + count,
        0
      );
      const uniqueJobs = Object.keys(applicationsPerJob).length;
      monthlyAverages[monthLabel] = uniqueJobs > 0 ? totalApplications / uniqueJobs : 0;
    } else if (!value.data.reportNotFound) {
      return;
    }
  });

  const sortedLabels = sortLabelsChronologically(Object.keys(monthlyAverages));

  return {
    labels: sortedLabels,
    datasets: [
      {
        label: 'Average Applications per Job',
        data: sortedLabels.map((label) => monthlyAverages[label]),
        borderWidth: 1,
        backgroundColor: COLORS[0],
        fill: false
      }
    ]
  };
};
